import { Grid } from '@mui/material';

import {
  InfoField,
  Paper,
  Divider,
  StatusChip,
  NO_DATA_PLACEHOLDER,
} from '@occc-app/design-system';
import { PromocodeFragment } from '@occc/graphql';

import { PromocodeStats } from '../../components/PromocodeStats';
import {
  chipVariantByPublicationStatus,
  getPromocodeStatusChipVariant,
  getPromocodeStatusTitle,
  titleByPublicationStatus,
} from '../../promocodes.constants';

type PromocodeDetailsPageProps = {
  code: string;
  description: string;
  createdBy: string;
  startDate: string;
  endDate: string;
  stats: PromocodeFragment['stats'];
  status: PromocodeFragment['status'];
  publicationStatus: PromocodeFragment['publicationStatus'];
};
export const PromocodeDetailsPage = (props: PromocodeDetailsPageProps) => {
  const { code, description, createdBy, endDate, startDate, status, stats, publicationStatus } =
    props;

  return (
    <Paper sx={{ p: 3 }}>
      <Grid container columnSpacing={1}>
        <Grid item xs={3}>
          <InfoField label='Promo Code' value={code} />
        </Grid>
        <Grid item xs={3}>
          <InfoField
            label='Promo Code Impact'
            value={
              stats ? (
                <PromocodeStats
                  redemptions={stats.redemptions}
                  totalOfferRedemptions={stats.totalOfferRedemptions}
                />
              ) : (
                NO_DATA_PLACEHOLDER
              )
            }
          />
        </Grid>
        <Grid item xs={3}>
          <InfoField label='Description' value={description} />
        </Grid>
        <Grid item xs={3}>
          <InfoField label='Created by' value={createdBy} />
        </Grid>
      </Grid>
      <Divider sx={{ my: 3 }} />
      <Grid container columnSpacing={1}>
        <Grid item xs={3}>
          <InfoField label='Start Date' value={startDate} />
        </Grid>
        <Grid item xs={3}>
          <InfoField label='End Date' value={endDate} />
        </Grid>
        <Grid item xs={3}>
          <InfoField
            label='Status'
            value={
              <StatusChip
                label={getPromocodeStatusTitle(status)}
                variant={getPromocodeStatusChipVariant(status)}
              />
            }
          />
        </Grid>
        <Grid item xs={3}>
          <InfoField
            label='Publication Status'
            value={
              <StatusChip
                label={titleByPublicationStatus[publicationStatus]}
                variant={chipVariantByPublicationStatus[publicationStatus]}
              />
            }
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
